import { createSelector } from 'reselect'

import { selectStrategicInitiativesState } from './selectStrategicInitiativesState'

export const selectStrategicInitiativesYearOptions = createSelector(
  [selectStrategicInitiativesState],
  (state) => state.yearOptions
)
